// extracted by mini-css-extract-plugin
export var alertIcon = "_pb-0";